import React from "react";
import { StatusIndicator } from "@cloudscape-design/components";
import { WorkflowStatus } from "../../services";

interface StatusBadgeProps {
  status: WorkflowStatus;
}

type IndicatorType = "success" | "error" | "in-progress" | "warning" | "stopped";

const STATUS_MAP: Record<WorkflowStatus, IndicatorType> = {
  [WorkflowStatus.SUCCEEDED]: "success",
  [WorkflowStatus.FAILED]: "error",
  [WorkflowStatus.RUNNING]: "in-progress",
  [WorkflowStatus.TIMED_OUT]: "warning",
  [WorkflowStatus.ABORTED]: "stopped",
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => (
  <StatusIndicator type={STATUS_MAP[status]}>{status}</StatusIndicator>
);
